<template>
  <div class="slide-search-container">
    <div
      ref="popupContainerRef"
      v-click-outside="vcoConfig"
      class="popup-container improve-slide-search"
    >
      <div class="main-content">
        <div class="slides-container">
          <SlideTypeListV2
            v-if="canMergePickImageIntoPickAnswer"
            :wrapperId="wrapperId"
            class="slide-type-list--side-left"
          />
          <SlideTypeList
            v-else
            :wrapperId="wrapperId"
            class="slide-type-list--side-left"
          />

          <div
            ref="previewRef"
            class="preview"
            :class="{
              visual: true,
            }"
          >
            <div class="preview-content">
              <CanvasPreview v-if="!isIOS" :wrapperId="wrapperId" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import SelectSlideTypeMixin from '@/mixins/slide/SelectSlideTypeMixin'
import CanvasPreview from '@/components-v2/common/canvas-preview/CanvasPreview.vue'
import SlideTypeList from '@/components-v2/presentation-editor/new-slide/SlideTypeList.vue'
import SlideTypeListV2 from '@/components-v2/presentation-editor/new-slide/SlideTypeListV2.vue'

import EventBus from '@/eventBus'
import { isIOS } from '@/utils/dom.utils'

export default {
  components: {
    CanvasPreview,
    SlideTypeList,
    SlideTypeListV2,
  },
  mixins: [SelectSlideTypeMixin],
  props: {
    closeSlideSearchPopup: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      wrapperId: 'slide-search-popup',
      isShowPreview: false,
      vcoConfig: {
        handler: this.handler,
        middleware: this.middleware,
      },
      isIOS: isIOS(),
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    ...mapGetters('featureToggles', ['canMergePickImageIntoPickAnswer']),
  },
  created() {
    EventBus.$on('slide-search-popup:close', this.closeSlideSearchPopup)
    EventBus.$on('handleHoverOnSlideType', this.handleHoverOnSlideType)
  },
  mounted() {
    if (this.$store.state.createdPresentationFromQuizHintsBanner) {
      const payload = { // create a quiz slide
        item: {
          name: 'Pick Answer',
          icon: 'fas fa-tasks',
          type: 'pickAnswer',
          slideType: null,
          desc: 'Ask a quiz question and write the options. Participants try to choose the correct answer to score points.',
          label: 'Quiz',
          ahaIcon: 'pick-answer',
          ahaIconWhite: 'pick-answer-w',
          preview: 'pickAnswer',
          previewUrl: '/723e47a009d5db8436363ef227c6577a.svg',
          videoTutorialUrl: 'https://youtu.be/RGX2dmuvTEA',
          error: false,
          isLoading: false,
        },
        property: 'quiz-hints-banner',
      }
      this.handleSelectSlideType(payload)
    }
  },
  destroyed() {
    EventBus.$off('slide-search-popup:close', this.closeSlideSearchPopup)
  },
  methods: {
    async handleSelectSlideType(payload) {
      await this.selectSlideType(payload) // mixin SelectSlideType
      this.closeSlideSearchPopup()
    },
    handleHoverOnSlideType(item, mode) {
      if (this.$store.state.isTouchScreen) return

      this.isShowPreview = mode === 'over'
    },
    handler() {
      this.closeSlideSearchPopup()
    },
    middleware(event) {
      const ignoreSelectors = [
        '.new-slide-context-cta',
        '.slides-container',
        '.aha-modal__content',
        '.tooltip',
        '.generator_stop-icon-svg',
        '.generate_send-icon',
      ]
      const isClickedByElement = ignoreSelectors.some((selector) => event.target.closest(selector))
      return !isClickedByElement
    },
  },
}
</script>

<style lang="scss" scoped>
.popup-container {
  position: relative;
  display: flex;
  width: 500px;
  height: calc(100% - 65px);
  margin-top: 16px;
  margin-left: 20px;
}

.main-content {
  height: 100%;
  width: 100%;
}

.slides-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.preview {
  pointer-events: none;
  position: absolute;
  width: 42vw;
  max-width: 676px;
  height: auto;
  top: 232px;
  left: calc(100% + 20px);
  box-shadow: 0px 4px 27px rgba(0, 0, 0, 0.03);
  border-radius: 8px;
  aspect-ratio: 676 / 578 !important;
  overflow: hidden;

  &.visual {
    top: 120px;
    aspect-ratio: 1622 / 906 !important;
  }
}
.slide-type-list--side-left {
  @apply overflow-y-auto bg-base-0 px-5 py-8 rounded-lg;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
  &::-webkit-scrollbar {
    width: 10px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    background: #fafafa;
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #c7c7c8;
    border-radius: 20px;
    width: 70%;
  }
}

.slide-search-container {
  background-color: rgba(0, 0, 0, .8); // https://stackoverflow.com/a/14525563
  @apply h-full w-full absolute top-0 left-0 z-10;
  /* if backdrop support: very transparent and blurred */
  // https://stackoverflow.com/a/44366154
  // Fix firefox not support backdrop-filter
  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background: rgba(0, 0, 0, 0.4);
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
  }
}

</style>
